import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AuthNotice} from './auth-notice.interface';

@Injectable({
  providedIn: 'root'
})
export class AuthNoticeService {
  onNoticeChanged$: BehaviorSubject<AuthNotice>;

  // auth page desc.
  description$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor() {
    this.onNoticeChanged$ = new BehaviorSubject(null);
  }

  setNotice(message: string, type?: string) {
    const notice: AuthNotice = {
      message,
      type
    };
    this.onNoticeChanged$.next(notice);
  }

  setDescription(value: string) {
    this.description$.next(value);
  }
}
